import { useQuery } from "@tanstack/react-query";
import {
	fetchTaskList,
	type GetTaskListParams,
	getGeneratableDownDayPMs,
} from "../repositorie/TaskListRepositorie";

export const TASK_LIST_QUERY_KEYS = {
	all: ["task-list"] as const,
	list: (params: GetTaskListParams) => ["task-list", "list", params] as const,
	generatableDownDayPMs: (assetId: number | string | null) =>
		["task-list", "generatableDownDayPMs", assetId] as const,
};

export const useTaskList = (params: GetTaskListParams, enabled = true) => {
	const query = useQuery({
		queryKey: TASK_LIST_QUERY_KEYS.list(params),
		queryFn: () => fetchTaskList(params),
		enabled,
	});

	return {
		tasks: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error as Error | null,
	};
};

export const useGeneratableDownDayPMs = (
	assetId: number | string | null,
	enabled = true,
) => {
	const query = useQuery({
		queryKey: TASK_LIST_QUERY_KEYS.generatableDownDayPMs(assetId),
		queryFn: () => getGeneratableDownDayPMs(assetId),
		enabled,
	});

	return {
		rows: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error as Error | null,
	};
};
